<template>
    <div class="kb-mobile-login-bar">
        <div class="kb-mobile-login-bar__login">
            <kb-base-link :href="loginUrl" v-if="!isAuthenticated" class="kb-mobile-login-bar__loginlink jt-header-navi-main">
                Login
            </kb-base-link>
            <kb-base-link :href="logoutUrl" v-if="isAuthenticated" class="kb-mobile-login-bar__logoutlink jt-header-navi-main">
                Logout
            </kb-base-link>
        </div>
        <div class="kb-mobile-login-bar__register">
            <kb-base-link v-if="!isAuthenticated" :href="registerUrl" class="kb-mobile-login-bar__registerlink jt-header-navi-main">Neu registrieren</kb-base-link>
            <kb-base-link v-if="isAuthenticated" :href="profileUrl" class="kb-mobile-login-bar__profilelink jt-header-navi-main">Profil</kb-base-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "kb-mobile-login-bar",
    props: {
        loginUrl: {
            type: String,
        },
        logoutUrl: {
            type: String,
        },
        registerUrl: {
            type: String,
        },
        profileUrl: {
            type: String,
        },
        isAuthenticated: {
            type: Boolean,
            required: true
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors';

.kb-mobile-login-bar {

    display: flex;
    align-items: center;
    border-bottom: 1px solid $grey-lighter;

    &__login {
        width: 50%;
    }

    &__loginlink,
    &__logoutlink {
        text-decoration: none;
        color: $cTextPrimary;
        font-family: $fontFamilyRegular;
        font-size: $fontSizeRegular;
        font-weight: $fontWeightBold;
        padding: $spacingRegular 0;
        display: inline-block;
    }

    &__loginlinkicon,
    &__logoutlinkicon {
        position:relative;
        top:3px;
        padding-right:$spacingXs;
        font-size:1.3em;
    }

    &__register {
        position:relative;
        top:3px;
        width: 50%;
        text-align: right;
    }

    &__registerlink,
    &__profilelink {
        font-family: $fontFamilyRegular;
        font-size: $fontSizeRegular;
        color: $cTextSecondary;
        text-decoration: underline;
    }
}
</style>
